export const pageVariants = {
  initial: { opacity: 0 },
  animate: { 
    opacity: 1,
    transition: { 
      duration: 0.8,
      staggerChildren: 0.1 
    }
  },
  exit: { opacity: 0 }
}; 